<style scoped lang="scss">
    .cart-qty{
        span{
            top:2px;
            @media (max-width: 991px) {
                top:1px;
            }
        }
    }
</style>

<template>
    <div class="navbar_right-side d-flex align-items-center pe-3 ps-xxl-45 bg-theme menu-animate-single">

        <template v-if="version == 'cantina'">
            <a :href="'/'+lang+'/shop'" class="h7 h6-xxxl mb-0 pe-25 pe-xxl-4 me-3 text-decoration-none shop-menu-link h-100 d-inline-flex align-items-center border-end border-white border-white--opaque fw-bold py-xxl-35">
                <span class="text-smaller-90 text-md-default-size">SHOP</span>
            </a>
            <div class="d-flex align-items-center py-15 ps-0 cursor-pointer mx-xxl-2" @click="openCart">
                <div class="navbar_icon-link my-1">
                    <div class="ms-0">
                        <a class="d-flex" href="javascript:void(0)">
                        <span class="h7 cart-qty text-white position-absolute top-50 start-50 translate-middle">
                            <span class="position-relative text-smaller-80">
                                {{counter}}
                            </span>
                        </span>
                            <img src="/images/icons/assets-15.svg" alt="icona" class="mb-1" />
                        </a>
                    </div>
                </div>
            </div>
        </template>

        <template v-else>
            <a href="https://direct.bookingandmore.com/accommodation/e241f291-89b6-4acd-8c22-3310447d6f4e#/" target="_blank" class="h7 h6-xxxl ms-35 ms-lg-0 mb-0 pe-xxl-2 me-xxl-15 text-decoration-none shop-menu-link h-100 d-inline-flex align-items-center fw-bold py-xxl-35">
                <span class="text-smaller-90 text-md-default-size" v-if="lang == 'it'">PRENOTA</span>
                <span class="text-smaller-90 text-md-default-size" v-else-if="lang == 'de'">BUCHEN SIE JETZT</span>
                <span class="text-smaller-90 text-md-default-size" v-else>BOOK NOW</span>
            </a>
        </template>

    </div>
</template>

<script>
    export default {
        props: ['initCounter', 'cartLink', 'lang', 'version'],
        data() {
            return {
                counter: 0,
                menu_open: false,
            }
        },
        mounted() {

            this.counter = parseInt(this.initCounter);

            this.$eventHub.$on('cart.added', payload => {
                this.counter = parseInt(payload.count);
            });

            this.$eventHub.$on('cart.updated.simpleQty', payload => {
                this.counter = payload;
            });
        },
        methods: {
            openCart() {
                let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
                if(vw < 992 || this.counter == 0 || document.querySelectorAll('.side-menu').length <= 0) {
                    window.location.href = this.$root.langRoute('/carrello');
                }else{
                    this.$eventHub.$emit('cart.show', {});
                }
            },
        },
        beforeDestroy() {
            this.$eventHub.$off('cart.added');
            this.$eventHub.$off('cart.updated.simpleQty');
        },
    }
</script>
